<template>
  <Modal :footer-hide="false" :mask-closable="false" v-model="show" :title="title" :width="600" @on-cancel="clearFrom()">
    <table class="QHtable">
      <tr>
        <td class="strong"><b>改价方式</b></td>
        <td colspan="2">
          <RadioGroup v-model="form.updataPriceType" type="button" @on-change="updataPriceTypeChange">
            <Radio label="100">输入百分比加价</Radio>
            <Radio label="200">输入金额加价</Radio>
            <Radio label="300">采用平台原价</Radio>
          </RadioGroup>
        </td>
      </tr>
      <tr>
        <td class="strong"><b>发明专利</b></td>
        <td colspan="2">
          <Input prefix="md-add" v-model="form.updataPriceKind100" placeholder="输入加价数据" maxlength="100" :disabled="form.updataPriceType == 300">
            <Icon slot="suffix" custom="iconfont icon-baifenbi" v-show="form.updataPriceType == 100" />
            <Icon type="logo-yen" slot="suffix" v-show="form.updataPriceType == 200" />
            <Icon type="logo-yen" slot="suffix" v-show="form.updataPriceType == 300" />
          </Input>
        </td>
      </tr>
      <tr>
        <td class="strong"><b>新型实用</b></td>
        <td colspan="2">
          <Input prefix="md-add" v-model="form.updataPriceKind200" placeholder="输入加价数据" maxlength="100" :disabled="form.updataPriceType == 300">
            <Icon slot="suffix" custom="iconfont icon-baifenbi" v-show="form.updataPriceType == 100" />
            <Icon type="logo-yen" slot="suffix" v-show="form.updataPriceType == 200" />
            <Icon type="logo-yen" slot="suffix" v-show="form.updataPriceType == 300" />
          </Input>
        </td>
      </tr>
      <tr>
        <td class="strong"><b>外观设计</b></td>
        <td colspan="2">
          <Input prefix="md-add" v-model="form.updataPriceKind300" placeholder="输入加价数据" maxlength="100" :disabled="form.updataPriceType == 300">
            <Icon slot="suffix" custom="iconfont icon-baifenbi" v-show="form.updataPriceType == 100" />
            <Icon type="logo-yen" slot="suffix" v-show="form.updataPriceType == 200" />
            <Icon type="logo-yen" slot="suffix" v-show="form.updataPriceType == 300" />
          </Input>
        </td>
      </tr>
    </table>
    <div slot="footer">
      <Button @click="clearFrom">取消</Button>
      <Button type="primary" @click="saveOk()">确认价格</Button>
    </div>
  </Modal>
</template>

<script>
import data from "./data.js";
export default {
  data() {
    return {
      show: false,
      title: "修改专利价格",
      form: { ...data.data },
    };
  },
  created() {},
  methods: {
    // +----------------------------------------------------------------------
    // | Desc:清理表单
    // +----------------------------------------------------------------------
    hello() {
      this.show = true;
      this.title = "专利价格修改";
      this.form = this.$copyObj(data.data);
    },
    // +----------------------------------------------------------------------
    // | Desc:确认修改价格
    // +----------------------------------------------------------------------
    saveOk() {
      //综合赋值验证
      var parameter = this.form;
      if (this.form.updataPriceType != 300) {
        var parameter = this.$isSubmitValidGetPram(this, data);
        if (!parameter) {
          return;
        }
      };
      parameter.updataPriceType = parseInt(parameter.updataPriceType);
      parameter.updataPriceKind100 = parseInt(parameter.updataPriceKind100);
      parameter.updataPriceKind200 = parseInt(parameter.updataPriceKind200);
      parameter.updataPriceKind300 = parseInt(parameter.updataPriceKind300);
      this.$emit("updataPrice", parameter);
      this.clearFrom();
    },
    // +----------------------------------------------------------------------
    // | Desc:清理表单
    // +----------------------------------------------------------------------
    clearFrom() {
      this.loading = false;
      this.show = false;
      this.form = this.$copyObj(data.data);
    },

    // +----------------------------------------------------------------------
    // | Desc:清理表单
    // +----------------------------------------------------------------------
    updataPriceTypeChange(e) {
      if (e == 300) {
        this.form = {
          updataPriceType: 300,
          updataPriceKind100: 0,
          updataPriceKind200: 0,
          updataPriceKind300: 0,
        };
      } else {
        this.form = {
          updataPriceType: e,
          updataPriceKind100: "",
          updataPriceKind200: "",
          updataPriceKind300: "",
        };
      }
    },
  },
};
</script>
